import { TFunction } from "i18next";
import { DatePickerValidationError } from "../../enums/DatePickerValidationError";

export interface ScheduleEmailValidationError {
  date: DatePickerValidationError | undefined;
}

export const getDateValidationErrorMessage = (
  t: TFunction,
  validationError: DatePickerValidationError,
): string => {
  switch (validationError) {
    case DatePickerValidationError.EmptyDate:
      return t("emailCycles.emptyDateErrorMessage");
    case DatePickerValidationError.InvalidDate:
      return t("emailCycles.invalidDateErrorMessages");
    default:
      return validationError satisfies never;
  }
};

export const getScheduleEmailValidationErrorMessage = (
  t: TFunction,
  validationErrors: ScheduleEmailValidationError,
): Record<keyof ScheduleEmailValidationError, string | undefined> => ({
  date: validationErrors.date
    ? getDateValidationErrorMessage(t, validationErrors.date)
    : undefined,
});
